import { FormattedMessage } from "react-intl";

export default function ProductsPage() {
	return (
		<p className="text-sm text-muted-foreground">
			<FormattedMessage id="page.products.placeholder" defaultMessage="Products page" />
		</p>
	);
}
